export default {
  price_calc: '价格计算器',
  price_tips: '此页面仅提供价格估算功能，具体价格请以实际使用情况为准',
  price_simulation: '预估游戏上线后的数据表现',
  price_service_pur: '选择所需的服务项',
  price_simulation_tips: '将根据预估数据进行价格估算，不代表最终价格',
  price_region: '发布区域',
  price_game_type: '游戏类型',
  price_players_num: '玩家总数',
  price_btn_calc: '估算',
  price_btn_calc_re: '重新估算',
  price_cost_tips: '实际消费以使用情况为准，可能低于此价格，此数据仅供参考。',
  price_estimated_cost: '预估费用',
  price_view_detail: '查看明细',
  price_pack_up_detail: '收起明细',
  price_service: '服务项',
  price_estimated: '预估价格',
  price_description: '说明',
  price_subscription_fees: '订阅费',
  price_subscription_fees_tips:
    '该订阅费包含各在线服务一定免费额度，当全部所选购服务不存在免费额度时，无该笔订阅费',
  price_multiplayer: 'Multiplayer 多人对战',
  price_player: 'Player 玩家服务',
  price_party: 'Party 组队服务',
  price_lobby: 'Lobby 大厅服务',
  price_matchmaking: 'Matchmaking 匹配服务',
  price_microservice: 'Microservice 微服务',
  price_goals: 'Goals 目标服务',
  price_ds_hosting: 'DS Hosting DS 托管服务',
  price_social: 'Social 互动社交',
  price_friends: 'Friends 好友服务',
  price_text_chat: 'Text Chat 文本聊天',
  price_voice_chat: 'Voice Chat(GVoice) 语音聊天',
  price_guild: 'Guild 公会服务',
  price_leaderboards: 'Leaderboards 排行榜服务',
  price_economy: 'Economy 经济系统',
  price_game_items: 'Game Items 道具服务',
  price_store: 'Store(GMall) 商城',
  price_engage: 'Engagement 参与度',
  price_mails: 'Mails 邮箱服务',
  price_private_access: 'Private Access 隐私权限',
  price_command: 'Command 命令服务',
  price_analytics: 'Analytics 数据分析',
  price_dashboard: 'Dashboard 数据看板',
  price_telemetry: 'Telemetry 遥测监控',
  price_health_monitor: 'Health Monitor 健康监测',
  price_session_track: 'Session Track 玩家追踪',
  price_content: 'Content 内容更新',
  price_remote_config: 'Remote Config(BianQue) 远端配置',
  price_content_delivery: 'Content Delivery 下载更新',
  price_not_support: '该服务项暂不支持测算，请联系InGame团队进一步了解',
  price_additional_services: 'InGame附加服务，选择相关服务后该服务支持免费使用',
  price_area_cn: '国内发行',
  price_area_intl: '海外发行',
  price_moba: '多人在线战术竞技 MOBA',
  price_shooter_games: '射击游戏 Shooter Games',
  price_rpg: '角色扮演游戏 RPG',
  price_strategy_games: '策略游戏 Strategy Games',
  price_card_games: '卡牌游戏 Card Games',
  price_simulation_games: '模拟经营 Simulation Games',
  price_adventure_games: '冒险游戏 Adventure Games',
  price_action_games: '动作游戏 Action Games',
  price_racing_games: '竞速游戏 Racing Games',
  price_party_games: '派对游戏 Party Games',
  price_sports_games: '体育游戏 Sports Games',
  price_casual_games: '休闲游戏 Casual Games',
  price_survival_games: '生存游戏 Survival Games',
  price_open_world_games: '开放世界 Open World Games',
  price_fighting_games: '格斗游戏 Fighting Games',
  price_others: '其他类型 Others',
  price_service_tips: '请填写完整模拟场景且至少选中1个服务项',
};
